var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { ButtonTag, AnchorTag, SpanTag } from '../../Utils/AtomicTag';
import Loading from '../Loading';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { buttonShow: true };
        _this.handleClick = function (e) {
            var _a = _this.props, disabled = _a.disabled, onClick = _a.onClick, href = _a.href;
            var btn = _this.btn.current;
            _this.setState({
                buttonShow: !_this.state.buttonShow,
            });
            if (disabled)
                return;
            // if (!href && btn) {
            //   btn.setAttribute('click-animating', 'true')
            //   setTimeout(function() {
            //     if (btn) {
            //       btn.removeAttribute('click-animating')
            //     }
            //   }, 500)
            // }
            // @ts-ignore
            onClick(e);
        };
        _this.btn = React.createRef();
        return _this;
    }
    Button.prototype.render = function () {
        var _a = this.props, size = _a.size, children = _a.children, disabled = _a.disabled, className = _a.className, type = _a.type, href = _a.href, target = _a.target, htmlType = _a.htmlType, icon = _a.icon, loading = _a.loading, style = _a.style, ghost = _a.ghost, rest = __rest(_a, ["size", "children", "disabled", "className", "type", "href", "target", "htmlType", "icon", "loading", "style", "ghost"]);
        var buttonShow = this.state.buttonShow;
        var btnBaseClass = [
            'whitespace-no-wrap',
            'cursor-pointer',
            'rounded',
            'border',
            'border-solid',
            'relative',
        ];
        // 禁用状态
        var btnDisabledClass = ['cursor-not-allowed'];
        var btnStatusClass = btnBaseClass.concat(disabled || loading ? btnDisabledClass : []);
        // 文字链接
        var linkUnDisabled = ['active:text-brand-800', 'cursor-pointer'];
        var linkDisabled = [
            'text-gray-500',
            'hover:text-gray-500',
            'cursor-not-allowed',
        ];
        var linkStatusClass = disabled ? linkDisabled : linkUnDisabled;
        var spanClass = icon || loading ? ['ml-px-8'] : [];
        var anchorSm = ['text-xs'];
        var anchorMd = ['text-sm'];
        var anchorLg = ['text-base'];
        var anchorInfo = ['text-brand-600', 'hover:text-brand-600'];
        var buttonSm = ['pl-px-16', 'pr-px-16', 'h-px-24', 'leading-5', 'text-xs'];
        var buttonMd = ['pl-px-16', 'pr-px-16', 'h-px-32', 'leading-px-29'];
        var buttonLg = ['pl-px-32', 'pr-px-32', 'h-px-40', 'leading-9', 'text-base'];
        var buttonInfo = [
            'bg-brand-600',
            'border-brand-600',
            'text-white',
            'hover:bg-brand-400',
            'hover:border-brand-400',
            'active:bg-brand-800',
            'active:border-brand-800',
        ];
        var buttonDefault = [
            'text-gray-700',
            'bg-white',
            'border-gray-400',
            'hover:border-brand-400',
            'focus:border-brand-400',
            'hover:text-brand-400',
            'focus:text-brand-400',
            'active:text-brand-800',
            'active:border-brand-800',
        ];
        var newType = type;
        if (newType !== 'default' && newType !== 'info') {
            newType = 'default';
        }
        var setClsObj = {
            small: {
                info: {
                    button: __spread(buttonSm, buttonInfo),
                    anchor: __spread(anchorSm, anchorInfo),
                },
                default: {
                    button: __spread(buttonSm, buttonDefault),
                    anchor: __spread(anchorSm, anchorInfo),
                },
            },
            large: {
                info: {
                    button: __spread(buttonLg, buttonInfo),
                    anchor: __spread(anchorLg, anchorInfo),
                },
                default: {
                    button: __spread(buttonLg, buttonDefault),
                    anchor: __spread(anchorLg, anchorInfo),
                },
            },
            normal: {
                info: {
                    button: __spread(buttonMd, buttonInfo),
                    anchor: __spread(anchorMd, anchorInfo),
                },
                default: {
                    button: __spread(buttonMd, buttonDefault),
                    anchor: __spread(anchorMd, anchorInfo),
                },
            },
        };
        return href ? (React.createElement(AnchorTag, __assign({}, rest, { name: Button.NAME, onClick: this.handleClick, style: style, atomics: __spread(this.props.atomics, linkStatusClass, setClsObj[size][newType].anchor), href: href, target: target, className: className }),
            (icon || loading) && (loading ? React.createElement(Loading, { size: "small" }) : icon),
            children && React.createElement(SpanTag, { atomics: spanClass }, children))) : (
        // <Transition in={buttonShow} unmountOnExit={false} classNames="click-animating" timeout={500}>
        React.createElement(ButtonTag, __assign({}, rest, { name: Button.NAME, atomics: __spread(this.props.atomics, btnStatusClass, setClsObj[size][newType].button), type: htmlType, onClick: this.handleClick, style: style, ref: this.btn, className: className + " " + (ghost ? 'btn-ghost' : ''), disabled: disabled || loading }),
            (icon || loading) && (loading ? React.createElement(Loading, { size: "small" }) : icon),
            children && React.createElement(SpanTag, { atomics: spanClass }, children))
        // </Transition>
        );
    };
    Button.defaultProps = defaultProps;
    Button.NAME = 'button';
    Button.displayName = 'Button';
    return Button;
}(PureComponent));
export { Button };
